import { render, staticRenderFns } from "./PanelCheckbox.vue?vue&type=template&id=86d4ee5a"
import script from "./PanelCheckbox.vue?vue&type=script&lang=js"
export * from "./PanelCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports